module.exports = __webpack_public_path__ + "static/media/PoppinsRegular.093ee89b.ttf";